<div class="flex flex-col justify-center items-center border-primary-dark border-4 px-6 py-64 mx-4 my-48">
  <div>
    <div class="text-6xl font-bold text-primary-dark flex justify-center mb-8">Acceso denegado</div>
    <div class="text-2xl font-bold text-neutral-base mt-8">
      No tienes permisos para acceder a esta ULR, por favor vuelve al Inicio.
    </div>
  </div>
  <div class="mt-16">
    <app-buttons
      [label]="'Ir al inicio'"
      [routerLink]="'/inicio'" />
  </div>
</div>
